import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';
import Background from '@/assets/icons/cover-images/millionaire.png';

const VariationsStyles = createGlobalStyle`
 @font-face {
       font-family: 'CustomArial';
       src: url(${CustomArial});
   }
  
  .generated-images-holder-var23 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var23 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
    justify-content: space-between;
  }
  .right-holder-var23 {
    width: calc(50% - 6px);
    height: 100%;
    display: flex;
    background: url(${Background}) no-repeat center center;
    flex-direction: column;
    position: relative;
  }
  .right-image-holder-var23 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .question-var23 {
    line-height: 1.2;
    letter-spacing: 0.05em;
    height: 216px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    width: 100%;
    font-size: 48px;
    top: 40px;
    flex: 1;
    text-align: center;
    color: #fff;
    font-family: CustomArial;
    font-weight: 700;
    align-items: center;
    justify-content: center;
  }
  
  .break-var23 {
    position: absolute;
    background-color: white;
    width: 12px;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
  .half-image-var23 {
    width: calc(50% - 6px);
    height: 100%;
    object-fit: cover;
    position: relative;
    display: block;
  }

  .trivia-answer-var23  {
    white-space: nowrap;
    position: absolute;
    font-family: CustomArial;
    font-weight: 700;
    width: 100%;
    text-align: center;
    font-size: 40px;
    left: 0;
    color: #fff;
    letter-spacing: 1.2px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
  }
  .answer-a-var23 {
    top: 290px;
  }
  .answer-b-var23 {
    top: 374px;
  }
  .answer-c-var23 {
    top: 458px;
  }
  .answer-d-var23 {
    top: 543px;
  }
  .trivia-answer-var23 span {
    color: #fac514;
    margin-right: 8px;
  }
  .actual-photo-var23 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var23--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
